import React from 'react';
import {
  Source,
  People,
  Settings,
  Task,
  Loop,
  BugReport,
  Security,
} from '@mui/icons-material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined';

export const SIDEBAR_ITEMS = (projectId, canAccess, isReady) => {
  const items = [
     {
        id: 'home',
        label: 'Dashboard',
        url: `/project/${projectId}/dashboard`,
        icon: <DashboardIcon />,                     
        submenuBaseUrl: `/project/${projectId}/project-coverage`,
        policy: 'ViewProjectDashboard',
        submenu: [
          {
            id: 'project-coverage',
            label: 'Project Coverage',
            url: `/project/${projectId}/project-coverage`,
          },
          {
            id: 'requirement-coverage',
            label: 'Requirement Coverage',
            param: 'requirement-coverage',
          },
          { id: 'test-design', label: 'Test Design', param: 'test-design' },
          {
            id: 'test-execution',
            label: 'Test Execution',
            param: 'test-execution',
          },
          {
            id: 'test-automation',
            label: 'Test Automation',
            param: 'test-automation',
          },
          { id: 'defects', label: 'Defects', param: 'defects' },
        ],
      },
    {
      id: 'project-team',
      label: 'Project Team',
      url: `/project/${projectId}/project-team`,
      icon: <People />,
      policy: 'ViewProjectUsers',
    },
    {
      id: 'testsuites',
      label: 'Test Suites',
      url: `/project/${projectId}/testsuites`,
      icon: <Source />,
      policy: 'ViewTestSuite',
    },
    { id: 'agentic-ai', label: 'AI Agents', url: `/project/${projectId}/agentic-ai`, icon: <AutoAwesomeIcon />, policy: 'ViewAiAgents' },
    {
      id: 'testcases',
      label: 'Test Cases',
      url: `/project/${projectId}/testcases`,
      icon: <Task />,
      policy: 'ViewTestCases',
    },
    {
      id: 'testcycles',
      label: 'Test Cycles',
      url: `/project/${projectId}/testcycles`,
      icon: <Loop />,
      policy: 'ViewTestCycles',
    },
    {
      id: 'issues',
      label: 'Issues',
      url: `/project/${projectId}/issues`,
      icon: <BugReport />,
      policy: 'ViewProjectDashboard',
    },
    {
      id: 'configurations',
      label: 'Configurations',
      url: `/project/${projectId}/configurations`,
      icon: <Settings />,
      policy: 'ViewProjectConfig',
    },
  ];

  if (!isReady) return [];
  return items.filter((item) => !item.policy || canAccess(item.policy));
};

export const DOCUMENTATION_SIDEBAR_ITEMS = () => [
  {
    id: 'about',
    label: 'About GAINSS',
  },
  {
    id: 'getting-started',
    label: 'Getting Started',
    url: '',
    submenu: [
      {
        id: 'register',
        label: 'Registration',
        param: 'register',
      },
      {
        id: 'invite-members',
        label: 'Invite Members',
        param: 'invite-members',
      },
      {
        id: 'managing-team',
        label: 'Managing Team',
        param: 'managing-team',
      },
      {
        id: 'roles-permissions',
        label: 'Roles & Permissions',
        param: 'roles-permissions',
      },
      {
        id: 'dashboard',
        label: 'Dashboard',
        param: 'dashboard',
      },
    ],
  },
  {
    id: 'projects',
    label: 'Projects',
    url: ``,
    submenu: [
      {
        id: 'manage-projects',
        label: 'Manage Projects',
        param: 'manage-projects',
      },
      {
        id: 'add-project',
        label: 'Add Project',
        param: 'add-project',
      },
      {
        id: 'project-workflows',
        label: 'Project Workflows',
        param: 'project-workflows',
      },
      {
        id: 'project-team',
        label: 'Project Team',
        param: 'project-team',
      },
    ],
  },
  {
    id: 'reports',
    label: 'Reports',
    url: ``,
    submenu: [
      {
        id: 'test-automation',
        label: 'Test Automation',
        param: 'test-automation',
      },
      {
        id: 'defect-overview',
        label: 'Defect Overview',
        param: 'defect-overview',
      },
    ],
  },
  {
    id: 'configuration',
    label: 'Configurations',
    url: ``,
    submenu: [
      {
        id: 'manage-configurations',
        label: 'Manage Configurations',
        param: 'manage-configurations',
      },
      {
        id: 'execution-scope',
        label: 'Platforms & Coverage',
        param: 'execution-scope',
      },
      {
        id: 'jira-integration',
        label: 'Jira Integration',
        param: 'jira-integration',
      },
      {
        id: 'notification-conig',
        label: 'Notification',
        param: 'notification-config',
      },
       {
        id: 'ai-management',
        label: 'Ai Management',
        param: 'ai-management',
      },
    ],
  },
  {
    id: 'project-dashboard',
    label: 'Project Dashboard',
    url: ``,
    submenu: [
      {
        id: 'dashboard-metrics',
        label: 'Dashboard Metrics',
        param: 'dashboard-metrics',
      },
      {
        id: 'test-design-metrics',
        label: 'Test Design',
        param: 'test-design-metrics',
      },
      {
        id: 'test-execution-metrics',
        label: 'Test Execution',
        param: 'test-execution-metrics',
      },
      {
        id: 'test-automation-metrics',
        label: 'Test Automation',
        param: 'test-automation-metrics',
      },
      {
        id: 'defects-metrics',
        label: 'Defects',
        param: 'defects-metrics',
      },
    ],
  },
  {
    id: 'test-suites',
    label: 'Test Suites',
    url: ``,
    submenu: [
      {
        id: 'add-test-suite',
        label: 'Add Test Suite',
        param: 'add-test-suite',
      },
      {
        id: 'test-suite-actions',
        label: 'Test Suite Actions',
        param: 'test-suite-actions',
      },
      {
        id: 'add-test-cases-in-test-suites',
        label: 'Add Test Cases in Test Suites',
        param: 'add-test-cases-in-test-suites',
      },
    ],
  },
  {
    id: 'test-cases',
    label: 'Test Cases',
    url: ``,
    submenu: [
      {
        id: 'add-test-case',
        label: 'Add Test Case',
        param: 'add-test-case',
      },
      {
        id: 'import-export-test-cases',
        label: 'Import / Export Test Cases',
        param: 'import-export-test-cases',
      },
      {
        id: 'test-case-bulk-edit',
        label: 'Bulk Edit Test Cases',
        param: 'test-case-bulk-edit',
      },
      {
        id: 'test-case-actions',
        label: 'More Test Case Actions',
        param: 'test-case-actions',
      },
      {
        id: 'delete-test-cases',
        label: 'Delete Test Cases',
        param: 'delete-test-cases',
      },
    ],
  },
  {
    id: 'test-cycles',
    label: 'Test Cycles',
    url: ``,
    submenu: [
      {
        id: 'add-test-cycle',
        label: 'Add Test Cycle',
        param: 'add-test-cycle',
      },
      {
        id: 'add-testcaseto-testcycle',
        label: 'Add Test case To Test Cycle',
        param: 'add-testcaseto-testcycle',
      },
      {
        id: 'test-cycle-actions',
        label: 'More Test Cycle Actions',
        param: 'test-cycle-actions',
      },
      {
        id: 'delete-test-cycle',
        label: 'Delete Test cycle',
        param: 'delete-test-cycle',
      },
    ],
  },
  {
    id: 'linked-issues',
    label: 'Issues',
    url: ``,
    submenu: [
      {
        id: 'project-issues',
        label: 'Project issues',
        param: 'project-issues',
      },
    ],
  },

  {
    id: 'test-execution',
    label: 'Test Execution',
    url: ``,
    submenu: [
      {
        id: 'start-new-iteration',
        label: 'Start/Edit Iteration',
        param: 'start-edit-iteration',
      },
      {
        id: 'execute-test-cases',
        label: 'Execute Test Cases',
        param: 'execute-test-cases',
      },
      // {
      //   id: 'linking-issue',
      //   label: 'Linking Issues',
      //   param: 'linking-issue',
      // },
    ],
  },
  {
    id: 'test-intelligence',
    label: 'Test Intelligence',
    url: ``,
    submenu: [
      {
        id: 'test-plan-suggestions',
        label: 'Test Plan Suggestions',
        param: 'test-plan-suggestions',
      },
    ],
  },
  {
    id: 'test-automation',
    label: 'Test Automation',
    url: ``,
    submenu: [
      {
        id: 'configure-automation-tool',
        label: 'Configure Automation Tool',
        param: 'configure-automation-tool',
      },
      {
        id: 'assigning-job-workflow',
        label: 'Assigning Job/Workflow',
        param: 'assigning-job-workflow',
      },
      {
        id: 'running-automation',
        label: 'Running Automation',
        param: 'running-automation',
      },
    ],
  },
  {
    id: 'gainss-api',
    label: 'Gainss API',
    url: ``,
    submenu: [
      {
        id: 'generate-api-token',
        label: 'Generate API Token',
        param: 'generate-api-token',
      },
      {
        id: 'create-new-iteration',
        label: 'Create New Iteration',
        param: 'create-new-iteration',
      },
      {
        id: 'update-execution-status',
        label: 'Update Execution Status',
        param: 'update-execution-status',
      },
      {
        id: 'update-execution-step-status',
        label: 'Update Execution Steps',
        param: 'update-execution-step-status',
      },
      {
        id: 'add-execution-attachments',
        label: 'Add Execution Attachments',
        param: 'add-execution-attachments',
      },
    ],
  },
];

export const ADMIN_SIDEBAR_ITEMS = (canAccess, isReady) => {
  const items = [
    {
      id: 'customers',
      label: 'Customers',
      url: `/admin/customers`,
      icon: <People />,
    },
    {
      id: 'release-notes',
      label: 'Release Notes',
      url: `/admin/release-notes`,
      icon: <Source />,
    },
    {
      id: 'roles-permissions',
      label: 'Roles & Permissions',
      url: `/admin/roles-permissions`,
      icon: <Security />,
    },
  ];

  if (!isReady) return [];
  return items.filter((item) => !item.policy || canAccess(item.policy));
};

export const SETTINGS_SIDEBAR_ITEMS = (canAccess, isReady) => {
  const items = [
    {
      id: 'user-management',
      label: 'User Management',
      icon: <PeopleOutlineIcon />,
      url: '/settings',
      submenu: [
        { id: 'users', label: 'Users', param: 'users', policy: 'ManageUsers' },
        { id: 'roles', label: 'Roles & Permissions', param: 'roles', policy: 'ManageRolesAndPermissions' },
      ],
    },
    {
      id: 'ai-config',
      label: 'AI Config',
      icon: <SmartToyOutlinedIcon />,
      url: '/settings',
      param: 'ai-config',
      policy: 'ManageAiConfigOrg',
    },
  ];

  if (!isReady) return [];
  return items.reduce((acc, item) => {
    if (item.submenu) {
      const allowedSubmenu = item.submenu.filter(
        (sub) => !sub.policy || canAccess(sub.policy)
      );
      if (allowedSubmenu.length > 0) {
        acc.push({ ...item, submenu: allowedSubmenu });
      }
      return acc;
    }
    if (!item.policy || canAccess(item.policy)) {
      acc.push(item);
    }
    return acc;
  }, []);
};